import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, Provider, DEFAULT_CURRENCY_CODE, APP_ID, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';

// Agregar idioma `es-MX` a core de aplicación
import '@angular/common/locales/global/es-MX';

import { ToastrModule } from 'ngx-toastr';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker'
import { NgxMaskModule } from 'ngx-mask';
import { NgOtpInputModule } from 'ng-otp-input';

// import * as Sentry from "@sentry/angular";

import 'compressorjs/dist/compressor';

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { LoaderInterceptor } from './interceptors/loader/loader.interceptor';
import { CacheInterceptor } from './interceptors/cache/cache.interceptor';
import { TokenInterceptor } from './interceptors/token/token.intreceptor';
import { LoaderComponent } from './shared/loader/loader.component';
import { HttpErrorInterceptor } from './interceptors/error-handling/error-handling.interceptor';
import { NotyfToast } from './classes/notyf.toast';
import { AnalyticsModule } from 'src/infra/analytics/analytics.module';

import { SliderViewComponent } from './modules/slider-content/slider-view/slider-view.component';

import { FingerprintAIO } from '@awesome-cordova-plugins/fingerprint-aio/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';

import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';


declare var cordova: any;

export function getPlatformType(): 'ios' | 'android' | 'web' {
  return typeof cordova !== 'undefined' ? 'ios' : 'web';
}

export const providers: Provider[] = [
   FingerprintAIO,
   Geolocation,
   InAppBrowser,
   // { provide: APP_ID, useValue: 'monific-app' },
   { provide: LOCALE_ID, useValue: 'es-MX' },
   { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
   { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
   { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
   { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
   { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.GOOGLE_RECAPTCHA_SITE_KEY },
   { provide: DEFAULT_CURRENCY_CODE, useValue: '$' },
   {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
         showDialog: false,
      }),
   }, {
      provide: Sentry.TraceService,
      deps: [Router],
   },
   {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
   },
];

if (environment.production && !environment.isMobile) {
   //   providers.unshift([
   //     { provider: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: true }) },
   //     { provide: Sentry.TraceService, deps: [Router] },
   //     { provide: APP_INITIALIZER, useFactory: () => () => { }, deps: [Sentry.TraceService], multi: true }
   //   ])
}

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgOtpInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatSelectModule,
    AnalyticsModule,
    NgxMatSelectSearchModule,
    NgxMaskModule.forRoot(),
    MatDialogModule,
    RecaptchaV3Module,
    ToastrModule.forRoot({
      positionClass: getPlatformType() === 'web' ? 'toast-top-right' : 'toast-bottom-right', // Ajuste basado en la plataforma
      toastClass: 'toast-notif',
      preventDuplicates: true,
      toastComponent: NotyfToast,
      tapToDismiss: false,
      timeOut: 20000
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production && !environment.isMobile,
      registrationStrategy: 'registerImmediately'
    }),
    AppRoutingModule,
    SliderViewComponent,
  ],
  providers,
  bootstrap: [AppComponent]
})
export class AppModule { }

